import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FileUploader} from "ng2-file-upload";
import {fadeAnimation} from "../../animations/basic-animation";

@Component({
  selector: 'app-attachment-drag-drop',
  templateUrl: './attachment-drag-drop.component.html',
  styleUrls: ['./attachment-drag-drop.component.scss'],
  animations: [
    fadeAnimation
  ]
})
export class AttachmentDragDropComponent implements OnInit {

  @Input() accepts: string[] = ['image/png', 'image/jpeg', 'application/pdf'] //'image/png' | 'image/jpeg' | 'application/pdf'
  @Output() selectedFile = new EventEmitter<File>();
  @Output() selectedFileEvent = new EventEmitter<any>();

  file: File

  public uploader: FileUploader = new FileUploader({
    url: '',
    allowedMimeType: this.accepts
  });


  constructor() {
    this.uploader.onAfterAddingFile = (file) => {
      this.file = file._file
      this.selectedFile.emit(file._file)
    };
  }

  ngOnInit(): void {
  }

  onFileChange(fileChangeEvent: any) {
    this.file = fileChangeEvent.target.files[0]
    this.selectedFile.emit(this.file)
    this.selectedFileEvent.emit(fileChangeEvent)
  }
}
